import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// Authenticated profile route, mounted under the AppLayout shell. Reached from
// the account menu in the shell header.
//
// There is no edit route: seller-service has no seller-facing write endpoint for
// the seller record, so this is a detail view only.
export const profileRoutes: RouteRecordRaw[] = [
  {
    path: routes.PROFILE,
    name: 'PROFILE',
    component: () => import('./ProfilePage.vue'),
    meta: {
      requiresAuth: true,
      title: 'Profile',
      subtitle: 'Your account details, as Sliceal holds them.',
    },
  },
]
